import moment from "moment";

const fromPrefix = {
  de: "von",
  en: "from",
};

const toPrefix = {
  de: "bis",
  en: "to",
};

export default function MapPopup({ stop, locale }) {
  moment.locale(locale);

  const {
    start_earliest: startEarliest,
    start_latest: startLatest,
    end_earliest: endEarliest,
    end_latest: endLatest,
    color: backgroundColor,
    motivation,
  } = stop;

  const getPeriodString = () => {
    const getDateString = (date) => moment(date).format("DD. MMM YYYY");

    if (
      startEarliest === startLatest &&
      endEarliest === endLatest &&
      startEarliest === endEarliest
    ) {
      return {
        start: getDateString(startEarliest),
      };
    }

    let start;
    let end;

    if (startEarliest === startLatest) {
      start = getDateString(startEarliest);
    } else {
      start = `${getDateString(startEarliest)} / ${getDateString(startLatest)}`;
    }

    if (endEarliest === endLatest) {
      end = getDateString(endEarliest);
    } else {
      end = `${getDateString(endEarliest)} / ${getDateString(endLatest)}`;
    }

    return {
      start,
      end,
    };
  };

  const { start, end } = getPeriodString();

  return (
    <div>
      <div className="popup-content" style={{ background: backgroundColor }}>
        <div className="dates">
          <table>
            <tr>
              {end && <td className="pr-3">{fromPrefix[locale]} </td>}
              <td>{start}</td>
            </tr>
            <tr>
              {end && <td className="pr-3">{toPrefix[locale]} </td>}
              {end && <td>{end}</td>}
            </tr>
          </table>
        </div>
        {motivation && <div className="motivation">{motivation}</div>}
      </div>
      <svg
        className="popup-anchor"
        style={{ color: backgroundColor }}
        viewBox="0 0 100 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="0" y1="3" x2="90" y2="3" strokeLinecap="butt" />
        <line x1="90" y1="3" x2="100" y2="20" strokeLinecap="butt" />
      </svg>
    </div>
  );
}
